import type { GridApi } from 'ag-grid-community'

/** Visible row IDs in filter/sort order — used for drawer prev/next navigation. */
export const collectVisibleAgGridRowIds = <TRow extends { id?: string }>(
  api: GridApi<TRow>,
): string[] => {
  const ids: string[] = []
  api.forEachNodeAfterFilterAndSort((node) => {
    const id = node.data?.id
    if (id) {
      ids.push(id)
    }
  })
  return ids
}
